var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXmasLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 95,
    height: 95,
    viewBox: "0 0 95 95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_61",
    "data-name": "Group 61",
    transform: "translate(-133 -75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(-1.545 75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(-0.455)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    width: 95,
    height: 95,
    transform: "translate(135)",
    fill: "#f7b359"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M438.14,380.628a29.945,29.945,0,0,0,31.408,14.988,29.916,29.916,0,0,0-2.575,34.5,29.936,29.936,0,0,0,11.137-10.71,29.936,29.936,0,0,0,11.137,10.71,29.917,29.917,0,0,0-2.533-34.437,29.945,29.945,0,0,0,31.039-15.053,29.925,29.925,0,0,0-14.841-4.292,29.9,29.9,0,0,0,3.7-15,29.914,29.914,0,0,0-28.67,19.7,29.914,29.914,0,0,0-28.673-19.7,29.93,29.93,0,0,0,3.707,15A29.909,29.909,0,0,0,438.14,380.628Z",
    transform: "translate(-297.947 -268.582)",
    fill: "#ec4247"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M517.79,377.829a29.944,29.944,0,0,0-31.408-14.988,29.914,29.914,0,0,0,2.573-34.5,29.9,29.9,0,0,0-11.135,10.7,29.929,29.929,0,0,0-11.137-10.7,29.914,29.914,0,0,0,2.533,34.437,29.942,29.942,0,0,0-31.025,15.053,29.877,29.877,0,0,0,14.841,4.289,29.945,29.945,0,0,0-3.721,15,29.917,29.917,0,0,0,28.672-19.7,29.916,29.916,0,0,0,28.67,19.7,29.91,29.91,0,0,0-3.7-15A29.893,29.893,0,0,0,517.79,377.829Z",
    transform: "translate(-297.983 -244.876)",
    fill: "#1c7c62"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXmasLogo);
export default __webpack_public_path__ + "static/media/XmasLogo.18099600008e272e76e6b75ef2205ddd.svg";
export { ForwardRef as ReactComponent };